/* Header "Boutique" — interactions (voir sections/header-boutique-v2.liquid) */
(function () {
  function toggle(el, force) {
    var open = force !== undefined ? force : !el.classList.contains('is-open');
    el.classList.toggle('is-open', open);
    return open;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var boutiqueBtn = document.getElementById('hbv2-boutique-btn');
    var panel = document.getElementById('hbv2-panel');

    if (boutiqueBtn && panel) {
      boutiqueBtn.addEventListener('click', function () {
        var open = toggle(panel);
        boutiqueBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        boutiqueBtn.classList.toggle('is-active', open);
      });

      document.addEventListener('click', function (event) {
        if (!panel.classList.contains('is-open')) return;
        if (panel.contains(event.target) || boutiqueBtn.contains(event.target)) return;
        toggle(panel, false);
        boutiqueBtn.setAttribute('aria-expanded', 'false');
        boutiqueBtn.classList.remove('is-active');
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (panel && panel.classList.contains('is-open')) {
        toggle(panel, false);
        if (boutiqueBtn) {
          boutiqueBtn.setAttribute('aria-expanded', 'false');
          boutiqueBtn.classList.remove('is-active');
        }
      }
      var openDrawer = document.querySelector('.hbv2-mdrawer.is-open');
      if (openDrawer) toggle(openDrawer, false);
    });

    // Generic tab groups (Catégories / Par besoin), desktop and mobile
    document.querySelectorAll('[data-hbv2-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.getAttribute('data-hbv2-tab-group');
        var target = btn.getAttribute('data-hbv2-tab');
        document.querySelectorAll('[data-hbv2-tab-group="' + group + '"][data-hbv2-tab]').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        document.querySelectorAll('[data-hbv2-tab-group="' + group + '"][data-hbv2-tabpanel]').forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-hbv2-tabpanel') === target);
        });
      });
    });

    // Accordion family blocks (hover on desktop via CSS, click/tap everywhere via JS)
    document.querySelectorAll('[data-hbv2-fam-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var fam = btn.closest('.hbv2-fam');
        if (fam) toggle(fam);
      });
    });

    // Le bandeau cookies (widget CMP #sd-cmp) affiche un bouton flottant en bas à
    // droite qui recouvre l'icône Panier de la barre basse mobile. On le décale
    // vers le haut sur mobile, et on le masque pendant que le tiroir Boutique
    // plein écran est ouvert (il flotte au-dessus sinon) — sans dépendre des
    // classes internes (variables) du widget : on cible tout élément
    // position:fixed proche du bas dans #sd-cmp.
    function repositionCookieWidget() {
      var root = document.getElementById('sd-cmp');
      if (!root) return;
      var mobile = window.innerWidth <= 990;
      var drawerOpen = !!document.querySelector('.hbv2-mdrawer.is-open');
      root.querySelectorAll('*').forEach(function (el) {
        var known = el.classList.contains('hbv2-cmp-fixed');
        if (!known) {
          var cs = window.getComputedStyle(el);
          if (cs.position !== 'fixed') return;
          // repère l'élément une seule fois (avant qu'on ne touche à son "bottom"),
          // sinon notre propre valeur (86px) finirait par échouer ce test.
          var bottomPx = parseFloat(cs.bottom);
          if (isNaN(bottomPx) || bottomPx > 80) return;
          el.classList.add('hbv2-cmp-fixed');
        }
        if (drawerOpen) {
          el.style.setProperty('opacity', '0', 'important');
          el.style.setProperty('pointer-events', 'none', 'important');
          return;
        }
        el.style.removeProperty('opacity');
        el.style.removeProperty('pointer-events');
        if (mobile) {
          el.style.setProperty('bottom', '86px', 'important');
        } else {
          el.style.removeProperty('bottom');
        }
      });
    }
    [500, 1500, 3000].forEach(function (delay) {
      setTimeout(repositionCookieWidget, delay);
    });
    window.addEventListener('resize', repositionCookieWidget);

    // Mobile fullscreen "Boutique" drawer, opened from the bottom tab bar or the search icon
    document.querySelectorAll('[data-hbv2-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var drawer = document.getElementById(btn.getAttribute('data-hbv2-drawer-open'));
        if (!drawer) return;
        toggle(drawer, true);
        document.documentElement.classList.add('hbv2-scroll-lock');
        document.querySelectorAll('.hbv2-tabbar-item').forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
        repositionCookieWidget();
        var focusId = btn.getAttribute('data-hbv2-focus-search');
        if (focusId) {
          setTimeout(function () {
            var input = document.getElementById(focusId);
            if (input) input.focus();
          }, 350);
        }
      });
    });

    document.querySelectorAll('[data-hbv2-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var drawer = btn.closest('.hbv2-mdrawer');
        if (!drawer) return;
        toggle(drawer, false);
        document.documentElement.classList.remove('hbv2-scroll-lock');
        var boutiqueTab = document.querySelector('.hbv2-tabbar-item[data-hbv2-drawer-open]');
        if (boutiqueTab) boutiqueTab.classList.remove('is-active');
        repositionCookieWidget();
      });
    });
  });
})();
